<template>
  <SlideYUpTransition :duration="animationDuration">
    <div class="modal fade"
         @click.self="closeModal"
         :class="[{'show d-block': show}, {'d-none': !show}, {'modal-mini': type === 'mini'}]"
         v-show="show"
         tabindex="-1"
         role="dialog"
         :aria-hidden="!show">

      <div class="modal-dialog modal-dialog-centered modal-right"
           :class="[{'modal-notice': type === 'notice'}, modalClasses]">
        <div class="modal-content" :class="[gradient ? `bg-gradient-${gradient}` : '',modalContentClasses]">

          <div class="modal-header" :class="[headerClasses]" v-if="$slots.header">
            <slot name="header"></slot>
            <slot name="close-button">
              <button type="button"
                    class="modal-close"
                      v-if="showClose"
                      @click="closeModal"
                      data-dismiss="modal"
                      aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
            </slot>
          </div>

          <div class="modal-body" :class="bodyClasses">
            <slot></slot>
          </div>

          <div class="modal-footer" :class="footerClasses" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>

    </div>
  </SlideYUpTransition>
</template>
<script>
import { SlideYUpTransition } from "vue2-transitions";

export default {
  name: "modal",
  components: {
    SlideYUpTransition
  },
  props: {
    show: Boolean,
    showClose: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "",
      validator(value) {
        let acceptedValues = ["", "notice", "mini"];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: 'Modal type (notice|mini|"") '
    },
    modalClasses: {
      type: [Object, String],
      description: "Modal dialog css classes"
    },
    modalContentClasses: {
      type: [Object, String],
      description: "Modal dialog content css classes"
    },
    gradient: {
      type: String,
      description: "Modal gradient type (danger, primary etc)"
    },
    headerClasses: {
      type: [Object, String],
      description: "Modal Header css classes"
    },
    bodyClasses: {
      type: [Object, String],
      description: "Modal Body css classes"
    },
    footerClasses: {
      type: [Object, String],
      description: "Modal Footer css classes"
    },
    animationDuration: {
      type: Number,
      default: 500,
      description: "Modal transition duration"
    }
  },
  methods: {
    closeModal() {
      this.$emit("update:show", false);
      this.$emit("close");
    }
  },
  watch: {
    show(val) {
      const documentClasses = document.body.classList;
      const documentElement = document.documentElement;

      if (val) {
        documentClasses.add("modal-open");
        documentElement.style.overflow = "hidden";
        document.querySelectorAll(".dashboard-navbar .nav-item.dropdown").forEach(element => {
          element.style.visibility = "hidden";
          element.style.pointerEvents = "none";
        });
        document.querySelectorAll(".navbar-top").forEach(element => {
          element.style.visibility = "hidden";
          element.style.pointerEvents = "none";
        });
      } else {
        documentClasses.remove("modal-open");
        documentElement.style.overflow = "";
        document.querySelectorAll(".dashboard-navbar .nav-item.dropdown").forEach(element => {
          element.style.visibility = "";
          element.style.pointerEvents = "";
        });
        document.querySelectorAll(".navbar-top").forEach(element => {
          element.style.visibility = "";
          element.style.pointerEvents = "";
        });
      }
    }
  }
};
</script>
<style>
.modal {
  position: fixed !important;
  inset: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  margin: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  z-index: 4000 !important;
  pointer-events: auto;
  backdrop-filter: blur(2px);
}

.modal.show {
  z-index: 4000 !important;
  background: linear-gradient(90deg, rgba(2, 6, 23, 0.18), rgba(2, 6, 23, 0.42));
}

.modal-right {
  margin: 0 0 0 auto;
  min-height: 100vh;
  min-height: 100dvh;
  height: 100%;
  max-width: 760px;
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  padding: 0;
}

.modal-right.modal-dialog-centered {
  align-items: flex-start;
}

.modal-right .modal-content {
  min-height: 0;
  height: 100%;
  max-height: 100vh;
  max-height: 100dvh;
  border-radius: 1.35rem 0 0 1.35rem;
  box-shadow: -18px 0 42px rgba(2, 6, 23, 0.26);
  border: 1px solid rgba(255, 255, 255, 0.14);
  overflow: hidden;
  animation: modalSlideIn 0.35s ease forwards;
  display: flex;
  flex-direction: column;
}

.modal-right .modal-header {
  border-bottom: 1px solid rgba(148, 163, 184, 0.16);
  padding: 1rem 1.3rem;
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.96), rgba(241, 245, 249, 0.96));
}

.modal-right .modal-close {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 50%;
  color: #334155;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 2.25rem;
  font-size: 1.75rem;
  font-weight: 400;
  height: 2.25rem;
  justify-content: center;
  line-height: 1;
  margin: -0.25rem -0.35rem -0.25rem auto;
  opacity: 1;
  padding: 0;
  transition: background-color 0.15s ease, color 0.15s ease;
  width: 2.25rem;
}

.modal-right .modal-close:hover {
  background-color: rgba(148, 163, 184, 0.18);
  color: #0f172a;
}

.modal-right .modal-close:focus {
  background-color: rgba(59, 130, 246, 0.14);
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.modal-right .modal-body {
  min-height: 0;
  padding: 1.2rem 1.3rem;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 auto;
  -webkit-overflow-scrolling: touch;
}

.modal-right .modal-footer {
  border-top: 1px solid rgba(148, 163, 184, 0.16);
  padding: 1rem 1.3rem;
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.96), rgba(241, 245, 249, 0.96));
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateX(24px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@media (max-width: 767.98px) {
  .modal,
  .modal.show {
    z-index: 4000 !important;
    width: 100vw;
    max-width: 100vw;
  }

  .modal-right {
    width: 100%;
    max-width: none;
    margin: 0;
  }

  .modal-right .modal-content {
    width: 100%;
    max-height: 100vh;
    max-height: 100dvh;
    border-radius: 0;
  }

  .modal-right .modal-header,
  .modal-right .modal-body,
  .modal-right .modal-footer {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
